import { Modal } from '@/components/utils/Modal';

interface DuplicatedItemsModalProps {
  open: boolean;
  isCopy?: boolean;
  onCancel: () => void;
  onMoveAll: () => void;
  onOk: () => void;
}

/**
 * Shown when dragging a card to a tab and the target dashboard already contains it.
 * - Ok: move/copy only non-duplicated items (removeDuplicates=false)
 * - Move All Of Them Into The New Column: move/copy all including duplicates (removeDuplicates=true)
 * - Cancel: abort the operation
 */
const DuplicatedItemsModal: React.FC<DuplicatedItemsModalProps> = ({
  open,
  isCopy = false,
  onCancel,
  onMoveAll,
  onOk,
}) =>
{
  const action = isCopy ? 'copy' : 'move';

  return (
    <Modal open={open} onClose={onCancel} title="Duplicated Items" preventCloseClickOut>
      <div className="w-[420px] mt-3">
        <p className="text-sm text-gray-700 leading-relaxed">
          Some of the items you want to {action} are already in that dashboard. Only new items will
          be {action}d.
        </p>

        <div className="pt-5 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="bg-brightGray hover:bg-corgee-brightGrayHover border text-white text-xs h-7 px-3 py-1"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onMoveAll}
            className="bg-corgee-blue hover:bg-corgee-blueHover border text-white text-xs h-7 px-4 py-1"
          >
            Move All Of Them Into The New Column
          </button>
          <button
            type="button"
            onClick={onOk}
            className="bg-corgee-blue hover:bg-corgee-blueHover border text-white text-xs h-7 px-3 py-1"
          >
            Ok
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DuplicatedItemsModal;
